import React, { useRef } from 'react'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  emojiButton: {
    backgroundColor: 'white',
    border: 'none',
    padding: '2px',
    '&:hover': {
      backgroundColor: theme.palette.primary.main
    },
    borderRadius: '5px'
  }
}))

const EmojiPickerRef = React.forwardRef(function EmojiPicker (props, ref) {
  const classes = useStyles(props)
  const emojiList = ['🙂', '😀', '😐', '🤩', '👍', '👎', '🤔', '😬', '😮', '❤️', '🙁', '😠', '🙏', '😂', '👆', '👇']
  const myRef = useRef()

  return (
    <div ref={ref} style={{ display: 'block', width: '0x', height: '0px' }}>
      <div className='cf-emoji-picker' ref={myRef} {...props}>
        {emojiList.map((emoji, index) => {
          return (
            <button
              className={classes.emojiButton}
              key={index}
              onClick={() => {
                props.onSelect({
                  native: emoji
                })
              }}
            >{emoji}
            </button>
          )
        })}
      </div>
    </div>
  )
})

export default EmojiPickerRef
